import React from "react";
import { Typography, IconButton, PaletteMode, Avatar, Box, Menu, MenuItem, Divider } from "@mui/material";
import { DarkMode, LightMode } from "@mui/icons-material";
import { StyledAppBar, StyledToolbar } from "./styles/Header.styled";
import { useAuth } from "../../feature-auth/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { signOut } from "../../feature-auth/services/authService";

interface HeaderProps {
    mode: PaletteMode;
    toggleMode: () => void;
}

const Header: React.FC<HeaderProps> = ({ mode, toggleMode }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        try {
            await signOut();
            navigate('/login');
        } catch (error) {
            console.error('Error signing out:', error);
        }
        handleClose();
    };

    const getInitials = (email: string) => {
        return email.charAt(0).toUpperCase();
    };

    return (
        <StyledAppBar position="static">
            <StyledToolbar>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                    <Typography
                        variant="h6"
                        component="div"
                        style={{ marginLeft: "12px", display: "flex", alignItems: "center" }}
                    >
                        ai.davidluff.de
                    </Typography>
                </div>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton onClick={toggleMode} color="inherit">
                        {mode === "dark" ? <LightMode /> : <DarkMode />}
                    </IconButton>
                    
                    {user && (
                        <>
                            <IconButton
                                onClick={handleMenu}
                                sx={{ p: 0 }}
                            >
                                <Avatar 
                                    sx={{ 
                                        bgcolor: mode === 'dark' ? 'primary.light' : 'primary.main',
                                        color: mode === 'dark' ? 'black' : 'white'
                                    }}
                                >
                                    {getInitials(user.email || '')}
                                </Avatar>
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem disabled sx={{ color: 'text.secondary' }}>
                                    Angemeldet als: {user?.email}
                                </MenuItem>
                                <Divider />
                                <MenuItem onClick={handleLogout}>Abmelden</MenuItem>
                            </Menu>
                        </>
                    )}
                </Box>
            </StyledToolbar>
        </StyledAppBar>
    );
};

export default Header;
